import { render, staticRenderFns } from "./Loadmoney.vue?vue&type=template&id=4b1fb62e&"
import script from "./Loadmoney.vue?vue&type=script&lang=js&"
export * from "./Loadmoney.vue?vue&type=script&lang=js&"
import style0 from "./Loadmoney.vue?vue&type=style&index=0&id=4b1fb62e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports